module.exports = __webpack_public_path__ + "static/media/Formato_de_Registro_de_incidentes.00c6ed6b.docx";